import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PlatOrgSealData } from '../models/staff/plat-org-seal-data.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmUserOrgSealDataService extends RequestService<PlatOrgSealData> {
  static PATH = '/om/user/org/sealData';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmUserOrgSealDataService.PATH, globalService.debugUrl);
  }
}
